import { Box, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    width: 47,
    height: 47,
    borderRadius: 27,
    backgroundColor: theme.darkGray,
    display: "grid",
    placeItems: "center",
  },
  text: {
    color: theme.white,
    fontSize: 12,
  },
}));

const Adjust = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Typography className={classes.text}>Adjust</Typography>
    </Box>
  );
};

export default Adjust;
